import { useStore } from '@/store'
import { Directive } from 'vue'

export const permission: Directive = {
  mounted(el, binding) {
    const { value } = binding
    if (!value.pkey || value.pkey.startsWith('NONE')) {
      return
    }
    const temp = useStore().state.permission.permissionsBtn
    if (temp && temp.length > 0) {
      const hasPermission = temp.some(item => {
        return item.icon === value.pkey
      })
      if (!hasPermission) {
        el.style.display = 'none'
      }
    } else {
      // 如果没有权限数据删除操作按钮
      el.style.display = 'none'
    }
  }
}
